var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 31 31"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16,3.5A15.5,15.5,0,0,0,31.5-12,15.5,15.5,0,0,0,16-27.5,15.5,15.5,0,0,0,.5-12,15.5,15.5,0,0,0,16,3.5Zm7.25-18.25A.752.752,0,0,1,24-14v4a.752.752,0,0,1-.75.75H16v4.425a.75.75,0,0,1-1.281.531L7.575-11.475a.743.743,0,0,1,0-1.056l7.144-7.181A.751.751,0,0,1,16-19.181v4.431Z",
  transform: "translate(-0.499 27.5)"
})));
export default SvgArrowLeft;